import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';

export const Container = styled.View`
  width: ${RFValue(28)}px;
  border-radius: ${RFValue(20)}px;
  height: ${RFValue(28)}px;
  background: ${({theme}) => theme.colors.primary_light};
  align-items: center;
  justify-content: center;
`;

export const IconItem = styled(FontAwesome)`
  font-size: ${RFValue(12)}px;
`;

export const IconItem5 = styled(FontAwesome5)`
  font-size: ${RFValue(12)}px;
`;

export const IconItemC = styled(MaterialCommunityIcons)`
  font-size: ${RFValue(12)}px;
`;
